module.exports = __webpack_public_path__ + "static/img/sc.68ac169.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sc.png
// module id = YY4J
// module chunks = 0